import $ from 'jquery';
import ProductHighlights from '../snippets/ProductHighlights';

export default class DynamicFeaturedProducts {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.productHighlights = new ProductHighlights(this.$el, this.section.postMessage);
  }

  onSectionUnload() {
    this.productHighlights.unload();
  }
}
